import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    checking: true,
    uid: null,
    name: null, 
    token: null,
    isLoggedin: false,
    tokenExpiresIn: null,
    /* allPlantaciones: false,
    indexPlantacion: 0, */
    
  },
  reducers: {
    login(state, action) {
      state.checking = action.payload.checking;
      //state.uid= action.payload.uid;
      state.name= action.payload.name;
      state.token= action.payload.token;
      state.isLoggedin= action.payload.isLoggedin;
      state.tokenExpiresIn = action.payload.tokenExpiresIn;
      //state.allPlantaciones= action.payload.allPlantaciones;
      //state.indexPlantacion= action.payload.indexPlantacion;
      
    },
    logout(state) {
      state.checking = false;
      state.isLoggedin=false;
    },
    checkingFinish(state) {
      state.checking = false;
    },
    
          
  },
});

export const authActions = authSlice.actions;

export default authSlice;
